!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, t = {}, s = {}, i = e.parcelRequire5f74;
  null == i && ((i = function(e) {
    if (e in t) return t[e].exports;
    if (e in s) {
      var i = s[e];
      delete s[e];
      var r = {
        id: e,
        exports: {}
      };
      return t[e] = r, i.call(r.exports, r, r.exports), r.exports;
    }
    var h = new Error("Cannot find module '" + e + "'");
    throw h.code = "MODULE_NOT_FOUND", h;
  }).register = function(e, t) {
    s[e] = t;
  }, e.parcelRequire5f74 = i), (0, i.register)("gjV2B", function(e, t) {
    var s, i, r, h;
    s = e.exports, i = "debounce", r = function() {
      return o;
    }, Object.defineProperty(s, i, {
      get: r,
      set: h,
      enumerable: !0,
      configurable: !0
    });
    const o = (e, t) => {
      let s;
      const i = (...i) => {
        clearTimeout(s), s = setTimeout(() => {
          clearTimeout(s), e(...i);
        }, t);
      };
      return i.cancel = () => {
        clearTimeout(s), s = null;
      }, i;
    };
  });
  var r = i("gjV2B");
  customElements.get("slider-component") || customElements.define("slider-component", class extends HTMLElement {
    constructor() {
      if (super(), this.slider = this.querySelector('[id^="Slider-"]'), !this.slider) return;
      this.slides = Array.from(this.querySelectorAll("[data-slide]")), this.sliderMarkers = this.querySelector('[id^="SliderMarkers-"]');
      const e = this.closest(".shopify-section");
      this.currentIndex = 0, this.controls = this.querySelector(".slider-controls") || e?.querySelector(".slider-controls"), 
      this.previous = this.querySelector("[data-previous]") || this.controls?.querySelector("[data-previous]") || e?.querySelector("[data-previous]"), 
      this.next = this.querySelector("[data-next]") || this.controls?.querySelector("[data-next]") || e?.querySelector("[data-next]"), 
      this.isSetup = !1, this.isVisible = null, this.arrowObserver = null, this.markerObserver = null, 
      this.displayObserver = null, this.controlsResizeObserver = null, this.hoverMQ = window.matchMedia("(hover: none)"), 
      this.tabletMQ = window.matchMedia("(max-width: 1024px)"), this.handleNext = this.handleNext.bind(this), 
      this.handlePrevious = this.handlePrevious.bind(this), this.handleHoverChange = this.handleHoverChange.bind(this), 
      this.handleTabletChange = this.handleTabletChange.bind(this), this.checkControlsVisibility = (0, 
      r.debounce)(this.checkControlsVisibility.bind(this), 100);
    }
    connectedCallback() {
      if (this.hasAttribute("data-hidden-destroy")) {
        const e = this.offsetWidth > 0 || this.offsetHeight > 0;
        this.isVisible = e, e && this.init(), this.displayObserver || this.setupDisplayObserver();
      } else this.init();
    }
    init() {
      this.handleHoverChange(this.hoverMQ), this.sliderMarkers && this.handleTabletChange(this.tabletMQ), 
      this.hoverMQ.addEventListener("change", this.handleHoverChange), this.sliderMarkers && this.tabletMQ.addEventListener("change", this.handleTabletChange), 
      this.setupControlsResizeObserver();
    }
    setupSlider() {
      !this.isSetup && (this.previous || this.next) && this.slides.length && (this.isSetup = !0, 
      this.previous?.addEventListener("click", this.handlePrevious), this.next?.addEventListener("click", this.handleNext), 
      !this.arrowObserver && this.slider.clientWidth > 0 && (this.arrowObserver = this.createArrowObserver(), 
      this.slides.length > 1 && (this.arrowObserver.observe(this.slides[0]), this.arrowObserver.observe(this.slides[this.slides.length - 1]))), 
      this.slider.addEventListener("scroll", () => {
        const e = this.slider.scrollLeft;
        let t = 0, s = 1 / 0;
        this.slides.forEach((i, r) => {
          const h = Math.abs(i.offsetLeft - e);
          h < s && (s = h, t = r);
        }), this.currentIndex = t;
      }));
    }
    setupMarkers() {
      if (!this.markerObserver && this.sliderMarkers) {
        this.markerObserver = this.createMarkerObserver();
        for (const e of this.slides) this.markerObserver.observe(e);
      }
    }
    goToSlide(e) {
      this.slides[e] && (this.slider.scrollLeft = Math.round(this.slider.scrollLeft), 
      this.slider.scrollTo({
        left: this.slides[e].offsetLeft,
        behavior: "smooth"
      }), this.currentIndex = e);
    }
    checkControlsVisibility() {
      !this.slider || !this.controls || this.slider.clientWidth < 1 || (this.slider.scrollWidth > this.slider.clientWidth ? (this.controls.style.display = "", 
      this.controls.removeAttribute("aria-hidden")) : (this.controls.style.display = "none", 
      this.controls.setAttribute("aria-hidden", "true")));
    }
    runControlsVisibilityAfterLayout() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (this.checkControlsVisibility(), !this.slider) return;
          const e = this.slider.scrollWidth - this.slider.clientWidth;
          this.slider.scrollLeft > .2 * e && (this.slider.scrollLeft = 0);
        });
      });
    }
    setupControlsResizeObserver() {
      this.slider && this.controls && !this.controlsResizeObserver && (this.controlsResizeObserver = new ResizeObserver(() => {
        this.runControlsVisibilityAfterLayout();
      }), this.controlsResizeObserver.observe(this.slider), this.controlsResizeObserver.observe(this), 
      this.runControlsVisibilityAfterLayout());
    }
    handleNext() {
      const e = Number(getComputedStyle(this).getPropertyValue("--movement_columns")) || 1, t = Math.min(this.currentIndex + e, this.slides.length - 1);
      this.goToSlide(t);
    }
    handlePrevious() {
      const e = Number(getComputedStyle(this).getPropertyValue("--movement_columns")) || 1, t = Math.max(this.currentIndex - e, 0);
      this.goToSlide(t);
    }
    handleHoverChange(e) {
      const t = !e.matches, s = this.hasAttribute("data-tablet");
      t && !s || !t && s ? this.setupSlider() : this.destroySlider();
    }
    handleTabletChange(e) {
      e.matches ? this.setupMarkers() : this.destroyMarkers();
    }
    createArrowObserver() {
      return new IntersectionObserver(e => {
        for (const t of e) {
          if ("none" === getComputedStyle(this).display) continue;
          const e = this.slides.indexOf(t.target), s = t.isIntersecting;
          0 === e ? (this.previous?.setAttribute("aria-hidden", s), s ? (this.previous?.setAttribute("disabled", ""), 
          this.previous?.classList.add("invisible", "pointer-events-none")) : (this.previous?.removeAttribute("disabled"), 
          this.previous?.classList.remove("invisible", "pointer-events-none"))) : e === this.slides.length - 1 && (this.next?.setAttribute("aria-hidden", s), 
          s ? (this.next?.setAttribute("disabled", ""), this.next?.classList.add("invisible", "pointer-events-none")) : (this.next?.removeAttribute("disabled"), 
          this.next?.classList.remove("invisible", "pointer-events-none")));
        }
      }, {
        root: this.slider,
        threshold: .95
      });
    }
    createMarkerObserver() {
      return new IntersectionObserver(e => {
        for (const t of e) if (t.isIntersecting) {
          this.sliderMarkers.querySelector("[data-active]")?.removeAttribute("data-active");
          const e = this.slides.indexOf(t.target);
          this.sliderMarkers.querySelector(`[data-position-marker="${e}"]`)?.setAttribute("data-active", "");
        }
      }, {
        root: this.slider,
        threshold: .95
      });
    }
    setupDisplayObserver() {
      this.displayObserver = new ResizeObserver(e => {
        if (!e || !e.length) return;
        const t = e[0], s = t.contentRect.width > 0 || t.contentRect.height > 0;
        this.isVisible !== s && (s ? this.init() : this.destroy(), this.isVisible = s);
      }), this.displayObserver.observe(this);
    }
    destroy() {
      this.destroySlider(), this.destroyMarkers(), this.destroyControlsResizeObserver(), 
      this.hoverMQ.removeEventListener("change", this.handleHoverChange), this.sliderMarkers && this.tabletMQ.removeEventListener("change", this.handleTabletChange);
    }
    destroySlider() {
      this.isSetup && (this.isSetup = !1, this.previous?.removeEventListener("click", this.handlePrevious), 
      this.next?.removeEventListener("click", this.handleNext), this.arrowObserver?.disconnect(), 
      this.arrowObserver = null);
    }
    destroyMarkers() {
      this.markerObserver && (this.markerObserver.disconnect(), this.markerObserver = null);
    }
    destroyControlsResizeObserver() {
      this.controlsResizeObserver?.disconnect(), this.controlsResizeObserver = null;
    }
    destroyDisplayObserver() {
      this.displayObserver?.disconnect(), this.displayObserver = null;
    }
    disconnectedCallback() {
      this.destroy(), this.destroyDisplayObserver(), this.destroyControlsResizeObserver();
    }
    refresh() {
      this.slides = Array.from(this.querySelectorAll("[data-slide]")), this.checkControlsVisibility(), 
      this.setupSlider(), this.arrowObserver && (this.arrowObserver.disconnect(), this.arrowObserver = null, 
      this.slides.length > 1 && this.slider.clientWidth > 0 && (this.arrowObserver = this.createArrowObserver(), 
      this.arrowObserver.observe(this.slides[0]), this.arrowObserver.observe(this.slides[this.slides.length - 1])));
    }
  });
}();